<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-credits`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 4c11.598 0 21 4.925 21 11s-9.402 11-21 11S3 21.075 3 15 12.402 4 24 4zM7 25H3l.004.21C3.224 31.09 12.644 35 24 35c11.49 0 21-4.004 21-10h-4l-.005.125C40.78 27.933 33.357 31 24 31c-9.497 0-17-3.16-17-6zm17 15c-9.497 0-17-3.16-17-6H3c0 5.996 9.51 10 21 10s21-4.004 21-10h-4c0 2.84-7.503 6-17 6zM7 15c0-3.165 7.32-7 17-7s17 3.835 17 7c0 3.166-7.32 7-17 7S7 18.166 7 15z"/></svg>
</template>
<script>

export default {
  name: 'IconCredits',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
